import { Injectable } from '@angular/core';
import { I18nService } from '@app/core';
import { ApiService } from './utility/api.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {

  private loggedInStatus = false;
  constructor(
    private Router: Router,
    private http: ApiService,
    private i18nService: I18nService) { }

  setLoggedIn(value: boolean) {
    this.loggedInStatus = value;
  }
  get isLoggedIn() {
    return this.loggedInStatus;
  }

  async GetProfile(User: string) {
    var data: any = {};
    data = await this.http.get('crmservice', 'agentProfile', 'username=' + User);
    return data;
  }

  async GetRole(RoleID: string) {
    var data: any = {};
    data = await this.http.get('master', 'agentBankRole');
    return await data.filter((a: any) => a["dpa_agentbankroleid"] == RoleID);
  }

  async LogIn(User: string, Password: string) {
    var req: any = {};
    req['username'] = User;
    req['password'] = Password;
    var data: any = {};
    data = await this.http.postnotauthen('crmservice', 'agentbankLogin', req);
    return data;
  }

  CheckSessionState(): boolean {
    if (localStorage.getItem("AgentBank_Profile") == '' || localStorage.getItem("AgentBank_Profile") == null) {
      this.Router.navigate(['login']);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts